import React from 'react'
import { Divider, List, ListItem, ListItemText, Popover, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import { useHistory } from 'react-router-dom'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { usePopover } from 'app/menu/components/TopBar/use-popover'
import { TopBarMenuItem } from './TopBarMenuItem'
import { TopBarListItem } from './TopBarListItem'
import { useTranslation } from 'react-i18next'
import { useGetHelpCenterURL } from 'utils/use-get-help-center-url'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'
import { useFeature } from '@cbgms/base/feature-flags'

export const HelpMenu: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const h = useHistory()
  const { helpCenterURL } = useGetHelpCenterURL()
  const [userEl, userOpen, handleUserClick, handleUserClose] = usePopover()
  const isPortal = useIsPortal()
  const isTopBarUXChangeForTimerEnabled = useFeature('topbar-ux-change-for-timer')
  const isScreen1440P = useMediaQuery('(min-width: 1440px)')

  if (isPortal) {
    return isTopBarUXChangeForTimerEnabled && isScreen1440P ? (
      <TopBarMenuItem badge={0} onClick={() => h.push('/contact')} startIcon={<HelpOutlineIcon />}>
        {t('Contact.TopBarTitle')}
      </TopBarMenuItem>
    ) : (
      <TopBarMenuItem badge={0} onClick={() => h.push('/contact')}>
        <Tooltip title={t('Contact.TopBarTitle')}>
          <HelpOutlineIcon />
        </Tooltip>
      </TopBarMenuItem>
    )
  }

  return (
    <>
      {isScreen1440P ? (
        <TopBarMenuItem isMenu badge={0} onClick={handleUserClick} startIcon={<HelpOutlineIcon />}>
          {t('Contact.TopBarTitle')}
        </TopBarMenuItem>
      ) : (
        <TopBarMenuItem badge={0} onClick={handleUserClick}>
          <HelpOutlineIcon />
        </TopBarMenuItem>
      )}
      <Popover
        open={userOpen}
        anchorEl={userEl}
        onClose={handleUserClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <List sx={{ minWidth: 160, maxWidth: 360 }} component='nav'>
          <TopBarListItem data-testid='contact' link='/contact' onClick={handleUserClose}>
            <ListItemText primary={t('Contact.ContactUsTopBar')} />
          </TopBarListItem>
          <Divider component='li' />
          <TopBarListItem onClick={handleUserClose}>
            <ListItem disablePadding component='a' href={helpCenterURL.toString()} target='_blank'>
              <ListItemText sx={{ color: theme.palette.text.primary }} primary={t('Contact.GuidesAndReleaseTopBar')} />
            </ListItem>
          </TopBarListItem>
        </List>
      </Popover>
    </>
  )
}
